import React, { Fragment } from "react";
import {
  Row,
  Col,
  Card,
  message,
  Button,
  Tooltip,
  Popover,
  Spin,
  Divider,
  Input,
  Popconfirm,
  notification
} from "antd";
import Basil from "basil.js";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { API, Storage } from "aws-amplify";
import moment from "moment";
import qs from "querystring";
import { S3Image } from "aws-amplify-react";
import CheckoutForm from "./components/checkout-form";
import OrderSummary from "./components/order-summary";
import OrderInput from "./components/OrderInput";
import { mappingActions } from "redux/modules/mappings";
import AutoSizer from "react-virtualized/dist/commonjs/AutoSizer";
import Table, {
  Column,
  SortDirection,
  SortIndicator
} from "react-virtualized/dist/commonjs/Table";
import orderBy from "lodash/orderBy";
import clipboard from "utils/clipboard";
import CSVUpload from "./components/csv-upload";
import * as Styled from "./styled";

const store = new Basil({ namespace: "fbq" });

class BulkOrder extends React.Component {
  constructor(props) {
    super(props);
    const query = qs.parse(props.location.search.substr(1));
    this.state = {
      showUploadModal: false,
      showCheckout: false,
      saving: false,
      success: false,
      loading: true,
      query: "",
      cart: {},
      data: [],
      mappings: [],
      file: null,
      sortBy: "name",
      sortDirection: SortDirection.ASC,
      userId: query.userId
    };

    if (query.userId) {
      store.remove("cart");
    }
  }

  componentWillMount() {
    this.props
      .dispatch(mappingActions.loadMappings(undefined, 0, this.state.userId))
      .then(resp => {
        const cart = store.get("cart") || {};
        const data = resp.results.map(i => {
          i.files = i.images.length;
          if (cart[i.id]) {
            // set the quantity to mapping item
            i.orderQty = cart[i.id];
          }
          return i;
        });
        // validate cart items
        Object.keys(cart).forEach(id => {
          const mapping = data.find(i => i.id === id);
          if (!mapping) {
            delete cart[id];
          }
        });
        this.setState({
          loading: false,
          mappings: data,
          data,
          cart
        });
      });
  }

  componentWillUpdate(nextProps, nextState) {
    const { sortBy: prevSortBy, sortDirection: prevSortDirection } = this.state;

    if (
      nextState.sortBy !== prevSortBy ||
      nextState.sortDirection !== prevSortDirection
    ) {
      const { sortBy, sortDirection } = nextState;
      let { data } = nextState;
      if (sortBy) {
        const defaultVal = sortDirection === SortDirection.ASC ? null : "";
        const sorted = orderBy(
          data,
          i => i[sortBy] || defaultVal,
          sortDirection.toLowerCase()
        );
        // if (sortDirection === SortDirection.DESC) {
        //   data = data.reverse();
        // }
        this.setState({ data: sorted, mappings: sorted });
      }
    }
  }

  rowGetter = ({ index }) => this._getDatum(this.state.mappings, index);

  _getDatum(list, index) {
    return list[index];
  }

  _sort = ({ sortBy, sortDirection }) => {
    const { sortBy: prevSortBy, sortDirection: prevSortDirection } = this.state;

    // If list was sorted DESC by this column.
    // Rather than switch to ASC, return to "natural" order.
    if (prevSortDirection === SortDirection.DESC) {
      sortBy = null;
      sortDirection = null;
    }

    this.setState({ sortBy, sortDirection });
  };

  toggleUpload = () => {
    this.setState({
      showUploadModal: !this.state.showUploadModal
    });
  };

  onUpload = (data, file) => {
    const { cart } = this.state;
    this.toggleUpload();
    const errors = [];
    data.forEach((i, idx) => {
      const item = this.state.data.find(
        d => d.name === i.name || (d.sku && d.sku === i.sku)
      );
      if (item) {
        cart[item.id] = Number(i.qty);
      } else {
        errors.push(idx);
      }
    });
    // validate cart items
    Object.keys(cart).forEach(id => {
      const mapping = this.state.data.find(i => i.id === id);
      if (!mapping) {
        delete cart[id];
      } else {
        mapping.orderQty = cart[id];
      }
    });
    this.setState({
      cart: { ...cart },
      file,
    });
    store.set("cart", cart);
    if (errors.length) {
      notification.warn({
        message: `Failed to match ${errors.length} row(s). Please check CSV row(s) ${errors.map(i => i +1).join(', ')}`,
        duration: 0,
      })
    }
  };

  handleSubmit = values => {
    const { cart, userId, file } = this.state;
    const {
      shipping,
      specialMessage,
      orderReference,
      deliveryAddress,
      returnAddress
    } = values;
    const items = [];
    Object.keys(cart).forEach(id => {
      const qty = cart[id];
      if (qty) {
        items.push({
          mappingId: id,
          quantity: qty
        });
      }
    });
    this.setState({ saving: true });
    API.post("api", "orders/bulk", {
      body: {
        shipping,
        orderReference,
        specialMessage,
        deliveryAddress,
        returnAddress,
        items,
        userId
      }
    })
      .then(order => {
        if (file) {
          const key = `csv/${order.orderId}.csv`;
          return Storage.vault.put(key, file, { level: "private" }).then(
            () => {
              return order;
            }
          );
        } else {
          return order;
        }
      })
      .then((order) => {
        this.setState({ saving: false, success: true, cart: {}, order });
        store.remove("cart");
      })
      .catch(e => {
        message.error(e.response.data.message);
        this.setState({ saving: false });
      });
  };

  setQty = (id, val) => {
    const { cart } = this.state;
    cart[id] = val;
    this.setState({ cart: { ...cart } });
    store.set("cart", cart);
  };

  remove = id => {
    const { cart } = this.state;
    delete cart[id];
    this.setState({
      cart: {
        ...cart
      }
    });
    store.set("cart", cart);
  };

  getRowClass = ({ index }) => {
    const { cart, mappings } = this.state;
    const mapping = mappings[index];
    if (!mapping) return "";
    const qty = cart[mapping.id];
    if (qty) return "highlight";
  };

  filter = () => {
    const { data, query } = this.state;
    const queryLower = query.toLowerCase();
    return data.filter(i => {
      const { name, sku } = i;
      if (name.toLowerCase().includes(queryLower)) return true;
      else if (sku && sku.toLowerCase().includes(queryLower)) return true;
      return false;
    });
  };

  onQueryChange = e => {
    this.setState(
      {
        query: e.target.value
      },
      () => {
        if (!this.state.query) {
          this.onSearch();
        }
      }
    );
  };

  onSearch = query => {
    if (query) {
      this.setState({ mappings: this.filter() });
    } else {
      this.setState({ mappings: this.state.data });
    }
  };

  pasteSearch = () => {
    clipboard(text => {
      if (text) {
        this.setState(
          {
            query: text
          },
          () => {
            this.setState({ mappings: this.filter() });
          }
        );
      }
    });
  };

  clearCart = () => {
    this.setState({ cart: {}, file: null });
    store.remove("cart");
  };

  resetPage = () => {
    this.setState({
      success: false,
      showCheckout: false,
      query: "",
      cart: {},
      mappings: this.state.data,
      order: null,
      file: null,
    });
  };

  renderQuantityCol = ({ cellData, rowData, isScrolling }) => {
    const { cart } = this.state;
    return (
      <OrderInput
        mapping={rowData}
        onChange={this.setQty}
        value={cart[rowData.id]}
        onRemove={this.remove}
        id={rowData.id}
      />
    );
  };

  renderCheckout = () => {
    return (
      <Styled.Checkout>
        <OrderSummary
          catalogs={this.props.catalogs}
          cart={this.state.cart}
          mappings={this.state.data}
        />
        <Divider />
        <CheckoutForm
          mappings={this.state.data}
          cart={this.state.cart}
          labData={this.props.labData}
          onSubmit={this.handleSubmit}
          saving={this.state.saving}
        />
      </Styled.Checkout>
    );
  };

  renderPopover = images => {
    return (
      <div>
        <S3Image level="public" imgKey={`resized/${images[0]}`} />
      </div>
    );
  };

  renderAvatarCol = ({ cellData, isScrolling }) => {
    return (
      <Popover
        trigger={["hover"]}
        content={this.renderPopover(cellData)}
        placement="right"
      >
        <span className="avatar">
          <S3Image level="public" imgKey={`resized/${cellData[0]}`} />
        </span>
      </Popover>
    );
  };

  renderSuccess = () => {
    const { order } = this.state;
    const id = "F-" + order.orderId;
    return (
      <Card className="text-center">
        <h2>Order Created: {id}</h2>
        <p>
          Your order # {id} has been placed. You should receive an email shortly
          with a summary of your order.
        </p>
        <Button type="primary" size="large" onClick={this.resetPage}>
          New Order
        </Button>
      </Card>
    );
  };

  render() {
    const { showUploadModal, success, mappings, data, loading } = this.state;

    return (
      <Styled.Container>
        <Helmet title="Create an Order" />
        {success ? (
          this.renderSuccess()
        ) : (
          <Spin spinning={loading}>
            <Row gutter={24}>
              <Col span={18}>
                <h1>Create an Order</h1>
                <p>
                  Enter the quantity you'd like to order from any of your
                  mappings below.
                </p>
                <p>
                  Please note that this ordering system is primarily for large
                  orders - if you mix different sizes larger than 8x10 in the
                  same order and you order less than 50 of each size we will
                  charge you extra for shipping.
                </p>
                <Input.Search
                  value={this.state.query}
                  size="large"
                  placeholder="Search..."
                  onSearch={this.onSearch}
                  onChange={this.onQueryChange}
                  style={{ width: 400 }}
                  enterButton
                  allowClear
                />{" "}
                <Tooltip title="Paste and search">
                  <Button
                    size="large"
                    icon="snippets"
                    onClick={this.pasteSearch}
                  />
                </Tooltip>{" "}
                <Button size="large" onClick={this.toggleUpload}>
                  Import CSV
                </Button>
                <AutoSizer disableHeight>
                  {({ width }) => (
                    <Table
                      rowCount={mappings.length}
                      height={500}
                      headerHeight={60}
                      width={width}
                      rowHeight={50}
                      overscanRowCount={10}
                      rowGetter={this.rowGetter}
                      rowClassName={this.getRowClass}
                      gridClassName="grid"
                      sort={this._sort}
                      sortBy={this.state.sortBy}
                      sortDirection={this.state.sortDirection}
                    >
                      <Column
                        headerRenderer={() => "Image"}
                        cellDataGetter={({ rowData }) => rowData.images}
                        cellRenderer={this.renderAvatarCol}
                        disableSort
                        width={60}
                      />
                      <Column
                        headerRenderer={({
                          dataKey,
                          sortBy,
                          sortDirection
                        }) => (
                          <span>
                            Name{" "}
                            {sortBy === dataKey && (
                              <SortIndicator sortDirection={sortDirection} />
                            )}
                          </span>
                        )}
                        cellDataGetter={({ rowData }) => rowData.name}
                        dataKey="name"
                        width={300}
                      />
                      <Column
                        headerRenderer={({
                          dataKey,
                          sortBy,
                          sortDirection
                        }) => (
                          <span>
                            Size{" "}
                            {sortBy === dataKey && (
                              <SortIndicator sortDirection={sortDirection} />
                            )}
                          </span>
                        )}
                        cellDataGetter={({ rowData }) => rowData.product_size}
                        dataKey="product_size"
                        width={80}
                      />
                      <Column
                        headerRenderer={({
                          dataKey,
                          sortBy,
                          sortDirection
                        }) => (
                          <span>
                            Files{" "}
                            {sortBy === dataKey && (
                              <SortIndicator sortDirection={sortDirection} />
                            )}
                          </span>
                        )}
                        cellDataGetter={({ rowData }) => rowData.files}
                        dataKey="files"
                        width={80}
                      />
                      <Column
                        label="Created on"
                        headerRenderer={({
                          dataKey,
                          sortBy,
                          sortDirection
                        }) => (
                          <span>
                            Date Created{" "}
                            {sortBy === dataKey && (
                              <SortIndicator sortDirection={sortDirection} />
                            )}
                          </span>
                        )}
                        cellDataGetter={({ rowData }) => rowData.createdAt}
                        cellRenderer={({ rowData }) =>
                          moment(rowData.createdAt).format("MMM D, YYYY")
                        }
                        dataKey="createdAt"
                        width={130}
                      />
                      <Column
                        label="History"
                        headerRenderer={({
                          dataKey,
                          sortBy,
                          sortDirection
                        }) => (
                          <span>
                            <Tooltip title="Number of orders using this mapping">
                              History
                            </Tooltip>{" "}
                            {sortBy === dataKey && (
                              <SortIndicator sortDirection={sortDirection} />
                            )}
                          </span>
                        )}
                        cellDataGetter={({ rowData }) => rowData.orders}
                        dataKey="orders"
                        width={100}
                      />
                      <Column
                        label="Order"
                        dataKey="orderQty"
                        headerRenderer={({
                          dataKey,
                          sortBy,
                          sortDirection
                        }) => (
                          <span>
                            Order{" "}
                            {sortBy === dataKey && (
                              <SortIndicator sortDirection={sortDirection} />
                            )}
                          </span>
                        )}
                        cellDataGetter={({ rowData }) => rowData.orderQty}
                        cellRenderer={this.renderQuantityCol}
                        width={270}
                      />
                    </Table>
                  )}
                </AutoSizer>
              </Col>
              <Col span={6}>
                <div>
                  {this.props.labData && this.renderCheckout()}
                  <Popconfirm title="Clear cart?" onConfirm={this.clearCart}>
                    <Button block type="link">
                      Clear Cart
                    </Button>
                  </Popconfirm>
                </div>
              </Col>
            </Row>
          </Spin>
        )}
        {showUploadModal && (
          <CSVUpload onClose={this.toggleUpload} onSubmit={this.onUpload} />
        )}
      </Styled.Container>
    );
  }
}

export default connect(state => ({
  ...state.lab
}))(BulkOrder);
